/**
 * Strips HTML tags and decodes common entities to plain text.
 * Kept in sync with StripHtmlPipe (replace order matters: decode &amp; last).
 */
export function stripHtmlToText(html: string): string {
  if (!html || typeof html !== 'string') return '';
  const stripped = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return stripped
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&');
}
